module.exports = __webpack_public_path__ + "media/images/Icône voiture-a07be9ba3c7d8875ff7997a9b726ae37.svg";